export const updateLog = holding => {
  return {
    type: 'xtract-auth@update-log',
    holding
  }
}

export const addToClickLog = event => {
  return {
    type: 'xtract-auth@add-to-log',
    event
  }
}